import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
// ✅ Import the centralized API logic and the base URL
import { loginApi, API_BASE } from "../utils/api";
import "../css/auth.css";

export default function LoginPage() {
  const { saveUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    
    try {
      // ✅ Use the neat loginApi function we created earlier
      const data = await loginApi(email, password);
      
      if (data.success) {
        saveUser(data.user, data.token);
        navigate("/");
      }
    } catch (err) {
      setMsg(err.response?.data?.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // ✅ Use API_BASE to dynamically route the Google Auth
    window.location.href = `${API_BASE}/auth/google`; 
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Welcome Back</h2>
          <p>Login to continue your journey.</p>
        </div>

        <form onSubmit={handleLogin}>
          <input 
            type="email" 
            placeholder="Email Address" 
            className="auth-input" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            placeholder="Password" 
            className="auth-input" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          
          {msg && <p style={{color: '#d11a1a', fontSize: '0.9rem', marginBottom: '10px', fontWeight: '600'}}>{msg}</p>}
          
          <button className="primary-btn" disabled={loading}>
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>

        <div className="divider"><span>OR</span></div>

        <div className="social-login">
          <button type="button" className="social-btn google-btn" onClick={handleGoogleLogin}>
            <img src="https://img.icons8.com/color/24/000000/google-logo.png" alt="G" />
            Login with Google
          </button>
        </div>

        <div className="auth-footer">
          Don't have an account? <Link to="/phoneauth" className="link-text">Sign up</Link>
        </div>
      </div>
    </div>
  );
}